import React, { useState } from 'react'
import { FeatureFlags } from '@mobi/settings'

import { VenueModeDiagnostics } from './Components/VenueModeDiagnostics'
import { useVenueProximity } from './Hooks/useVenueProximity'
import { useFeature } from '@core/Utils/hooks'
import {
  MessageStyled,
  OffersWrapperStyled,
  OffersContentStyled,
  DisabledOverlayStyled,
  TabContainerStyled,
  TabButtonStyled,
  TabContentStyled,
} from './VenueMode.styles'

type TabType = 'racing' | 'sports' | 'diagnostics'

export const VenueMode = (): React.JSX.Element => {
  const [activeTab, setActiveTab] = useState<TabType>('diagnostics')
  const isVenueModeDiagnosticsActive = useFeature(FeatureFlags.VENUE_MODE_DIAGNOSTICS.key)

  const { locationDetail } = useVenueProximity()
  const isInside = locationDetail.closestVenue?.inside

  const renderVenueModeTab = () => (
    <>
      {!isInside && (
        <MessageStyled>To unlock EXCLUSIVE OFFERS go to the nearest retail venue.</MessageStyled>
      )}
      <OffersWrapperStyled>
        <OffersContentStyled disabled={!isInside}>
          <MessageStyled>Coming Soon</MessageStyled>
        </OffersContentStyled>
        {!isInside && <DisabledOverlayStyled />}
      </OffersWrapperStyled>
    </>
  )

  return (
    <>
      <TabContainerStyled>
        <TabButtonStyled active={activeTab === 'racing'} onClick={() => setActiveTab('racing')}>
          Racing
        </TabButtonStyled>
        <TabButtonStyled active={activeTab === 'sports'} onClick={() => setActiveTab('sports')}>
          Sports
        </TabButtonStyled>
        {isVenueModeDiagnosticsActive && (
          <TabButtonStyled
            active={activeTab === 'diagnostics'}
            onClick={() => setActiveTab('diagnostics')}
          >
            Diagnostics
          </TabButtonStyled>
        )}
      </TabContainerStyled>

      <TabContentStyled>
        {activeTab === 'racing' && renderVenueModeTab()}
        {activeTab === 'sports' && renderVenueModeTab()}
        {isVenueModeDiagnosticsActive && activeTab === 'diagnostics' && (
          <VenueModeDiagnostics locationDetail={locationDetail} />
        )}
      </TabContentStyled>
    </>
  )
}
